import { useState, useEffect, useCallback, useRef } from "react";

import EventService from "../services/EventService";
import URLConverterService from "../services/URLConverterService";

import { BASE_PATH_AGENDA, BASE_PATH_ARCHIEF } from "../config";

const useFilters = (history, isArchive) => {
    const BASE_PATH = useRef(isArchive ? BASE_PATH_ARCHIEF : BASE_PATH_AGENDA);
    const previousQuery = useRef('');

    const [events, setEvents] = useState([]);

    const getFiltersFromUrl = useCallback(() => {
        const filtersString = history.location.pathname.replace(BASE_PATH.current, "");
        const filtersFromUrl = URLConverterService.parse(filtersString);

        return filtersFromUrl;
    }, [history.location.pathname]);

    const [pagination, setPagination] = useState({
        current: getFiltersFromUrl().page,
        total: 1,
    });
    const [activeFilters, setActiveFilters] = useState(getFiltersFromUrl().filters);
    const [loading, setLoading] = useState(false);

    const fetchEvents = useCallback(async (newFilters, newPage) => {
        const amount = 13;
        const events = await EventService.search(newFilters, amount, newPage, isArchive);

        setEvents(events.results);
        setPagination({ ...pagination, total: Math.ceil(events.total / amount) })
        setLoading(false);
    }, [pagination, isArchive]);

    useEffect(() => {
        const { pathname: query } = history.location;
        const newQuery = `${BASE_PATH.current}/${URLConverterService.stringify(activeFilters, pagination.current)}`;

        if (query !== newQuery) {
            history.push(newQuery);
        }
    }, [history, activeFilters, pagination]);

    useEffect(() => {
        const { pathname: query } = history.location;

        setLoading(true);
        setActiveFilters(getFiltersFromUrl().filters);
        setPagination({ ...pagination, current: getFiltersFromUrl().page });

        if (previousQuery.current !== query) {
            fetchEvents(getFiltersFromUrl().filters, getFiltersFromUrl().page);
            previousQuery.current = query;
        }
    }, [history.location.pathname, previousQuery]);

    const changeFilters = (newFilters) => {
        setActiveFilters(newFilters);
        setPagination({ ...pagination, current: 1 });
    };

    const changePagination = (newPagination) => {
        setPagination({ ...pagination, current: newPagination });
    };

    return [
        events,
        activeFilters,
        changeFilters,
        pagination,
        changePagination,
        loading,
    ];
};

export default useFilters;
